import React from "react";
import classNames from "classnames";
import ButtonBase from "@material-ui/core/ButtonBase";
import { useMediaQuery } from "@material-ui/core";
import TeamLogo from "./TeamLogo";
import teamButtonStyles from "../../football/styles/TeamButton.styles";

const TeamButton = ({ team, selected, onSelected, disabled, id }) => {
	const classes = teamButtonStyles();
	const xsScreen = useMediaQuery((theme) => theme.breakpoints.down("xs"));

	return (
		<ButtonBase
			focusRipple
			className={classNames(classes.image, {
				[classes.selected]: selected,
				[classes.disabled]: disabled
			})}
			focusVisibleClassName={classes.focusVisible}
			onClick={() => onSelected(team)}
			disabled={disabled}
			id={id}
			aria-label={team.teamName}
			aria-pressed={selected}
		>
			<TeamLogo team={team} hideName size={xsScreen ? "medium" : "large"} />
		</ButtonBase>
	);
};
export default TeamButton;
